import React from 'react'

const Quote = () => {
  return (
    <section className="w-full min-h-[40rem] bg-photo flex flex-col items-center justify-center p-4 text-white pb-24 gap-24">
      <p className='text-9xl font-playfair-bold'>,,</p>
      <h7 className="font-playfair-semibold text-6xl text-center lg:max-w-[50%]">Cooking is an art, and the kitchen is my canvas. Every dish is a masterpiece waiting to be savored.</h7>
      <p className="font-playfire text-lg">- Michelin Custain -</p>
    </section>
  )
}

export default Quote
